import {Component, Input} from '@angular/core'

@Component({
  selector: 'ErrorMessages',
  templateUrl: './html-templates/validation-error-messages.component.html'
})
export class ErrorMessagesComponent {
  @Input() errorMessages: string[] = []
  @Input() for: string = ""
}
